import { phone } from './helper/ValidatorRules'

const phoneValidator = {
  getMessage: () => 'Sorry, only numbers (0-9), and symbols (+) are allowed.',
  validate: value => {
    return {
      valid: phone(value),
      data: {
        required: true
      }
    }
  }
}

export default phoneValidator
